<micro-lookup domain="domain" obj="objectGroups" url="/objectGroups" [key]="objectGroupId"></micro-lookup>
